import { render, staticRenderFns } from "./new-module.vue?vue&type=template&id=f8603934&scoped=true"
import script from "./new-module.vue?vue&type=script&lang=js"
export * from "./new-module.vue?vue&type=script&lang=js"
import style0 from "./new-module.vue?vue&type=style&index=0&id=f8603934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8603934",
  null
  
)

export default component.exports